import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, ButtonLoader, MessageService } from '../../../../core';
import { Pessoa } from '../../pessoa';
import { PessoaCrudHttpService } from '../../services';
import { PessoaContatoFormComponent } from '../form';
import { PessoaContato } from '../pessoa-contato';
import { PessoaContatoHttpService } from '../services';
import { PessoaContatoTipo } from '../tipo';


@Component({
    selector: 'sgt-pessoa-contato-form-modal',
    templateUrl: './pessoa-contato-form-modal.component.html',
    styleUrls: ['./pessoa-contato-form-modal.component.less']
})
export class PessoaContatoFormModalComponent implements OnInit {
    private elModal: any;
    isLoading: boolean;
    editMode: boolean;
    showForm = false;
    private idPessoa: number;
    private tipoContato: PessoaContatoTipo;
    pessoa: Pessoa;
    private idContato: number;

    @Input() labelPessoa = '';
    @Output() afterSave = new EventEmitter<PessoaContato>();
    @ViewChild('form') form: PessoaContatoFormComponent;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private pessoaCrudHttpService: PessoaCrudHttpService,
                private pessoaContatoHttpService: PessoaContatoHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.load();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    insert(idPessoa: number, tipoContato: PessoaContatoTipo) {
        this.editMode = false;
        this.idPessoa = idPessoa;
        this.tipoContato = tipoContato;
        this.open();
    }

    edit(idPessoa: number, idContato: number) {
        this.editMode = true;
        this.idPessoa = idPessoa;
        this.idContato = idContato;
        this.open();
    }

    private open() {
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    private clear() {
        // this.form.resetForm();
        this.editMode = null;
        this.showForm = false;
        this.idPessoa = null;
        this.tipoContato = null;
        this.pessoa = null;
        this.idContato = null;
    }

    /** Carrega a pessoa do contato */
    private loadPessoa(): Promise<Pessoa> {
        return new Promise<Pessoa>((resolve, reject) => {
            this.pessoaCrudHttpService.load(this.idPessoa)
                .pipe(
                    take(1)
                )
                .subscribe(
                    pessoa => resolve(pessoa),
                    (error: ApiError) => reject(error)
                );
        });
    }

    /** Carrega o contato */
    private loadContato(): Promise<PessoaContato> {
        return new Promise<PessoaContato>((resolve, reject) => {
            this.pessoaContatoHttpService.load(this.idContato)
                .pipe(
                    take(1)
                )
                .subscribe(
                    contato => resolve(contato),
                    (error: ApiError) => reject(error)
                );
        });
    }

    private load() {
        this.isLoading = true;

        Promise.all([
            this.loadPessoa(),
            this.loadContato()
        ])
        .then((values) => {
            this.isLoading = false;
            this.pessoa = values[0];

            this.showForm = true;
            setTimeout(() => {
                if (this.editMode) {
                    this.form.edit(values[1]);
                } else {
                    this.form.insert(this.tipoContato?.id ?? null);
                }
            }, 0);
        })
        .catch((error: ApiError) => {
            this.messageService.error(error.message, 'Erro ao carregar o contato', error);
            this.isLoading = false;
            this.close();
        });
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Salva o contato */
    save() {
        if (!this.form.isValid()) {
            this.messageService.info('Para salvar o contato é preciso informar corretamente todos os campos destacados em vermelho', 'Informação');
            return;
        }

        try {
            const btnSave = new ButtonLoader('#btnPessoaContatoSave');
            btnSave.loading('Salvando');

            const contato = this.form.entity;
            if (this.editMode) {
                this.pessoaContatoHttpService.update(contato)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        response => {
                            this.messageService.success('', `Contato ${contato.nome} atualizado com sucesso`);
                            btnSave.reset();
                            this.afterSave.emit(response);
                            this.close();
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, `Erro ao atualizar o contato ${contato.nome}`, error);
                            btnSave.reset();
                        }
                    );
            }  else {
                this.pessoaContatoHttpService.insert(this.idPessoa, contato)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        response => {
                            this.messageService.success('', `Contato ${contato.nome} adicionando com sucesso`);
                            btnSave.reset();
                            this.afterSave.emit(response);
                            this.close();
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, `Erro ao adicionar o contato ${contato.nome}`, error);
                            btnSave.reset();
                        }
                    );
            }
        } catch (error) {
            this.messageService.error('Ocorreu um erro ao salvar o contato. Tente novamente', 'Erro', error);
        }
    }
}
